<template>
  <v-container fluid class="px-0 py-0">
    <v-card>
      <v-card-text>
        <div class="total-acc">
          共<b>{{ totalAcc }}</b>名标记在职学员
        </div>
        <p class="sys-alert" style="font-size: 12px;">
          该数据仅为当前系统数据，同时存在一人多职、多岗的情况。
        </p>
        <v-layout row wrap grid-list-md>
          <v-flex xs12 sm8 md9>
            <v-tabs centered light>
              <v-tab>按人员类型</v-tab>
              <v-tab>按业务类型</v-tab>
              <v-tab-item>
                <v-layout row wrap>
                  <v-flex xm12 sm4 md2 v-for="(o, idx) in typeAcc" :key="o.n">
                    <v-card class="panel panel-1" :color="!legendData || legendData[idx].show ? colors[idx] : ''
            " :dark="!legendData || legendData[idx].show" :style="{ cursor: legendData ? 'pointer' : 'auto' }" @click="setLegendData(idx)">
                      <v-card-text :title="o.n">
                        <div>
                          <v-icon :size="24" class="left-icon">person</v-icon>
                          <label>{{ o.c }}</label>
                        </div>
                        <div class="label">
                          <em>{{ o.n }}</em>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-divider />
                <div v-if="accChart">
                  <div style="text-align: right;">
                    <span style="font-size:12px;cursor: pointer" @click="accChartDataView = !accChartDataView">{{
            accChartDataView ? '图表视图' : '数据视图' }}</span>
                  </div>
                  <keep-alive>
                    <v-data-table :headers="accTableHader" :items="accTableData" v-if="accChartDataView"
                      class="elevation-1" :rows-per-page-items="[50, 100, { text: '全部', value: -1 }]">
                      <template v-slot:items="props">
                        <td v-for="header in accTableHader" :key="header.text">{{ props.item[header.value] }}</td>
                      </template>
                    </v-data-table>
                    <v-chart v-else class="v-chart" autoresize :option="accChart" :style="{
            height: accChart.yAxis[0].data.length * 60 + 60 + 'px',
          }" @click="onBarClick" />
                  </keep-alive>
                </div>
              </v-tab-item>
              <v-tab-item>
                <v-layout row wrap>
                  <v-flex xm12 sm4 md2 v-for="(o, idx) in vTypeAcc" :key="o.n">
                    <v-card class="panel panel-1" :color="!vLegendData || vLegendData[idx].show ? colors[idx] : ''
            " :dark="!vLegendData || vLegendData[idx].show" :style="{ cursor: vLegendData ? 'pointer' : 'auto' }" @click="setVLegendData(idx)">
                      <v-card-text :title="o.n">
                        <div>
                          <v-icon :size="24" class="left-icon">person</v-icon>
                          <label>{{ o.c }}</label>
                        </div>
                        <div class="label">
                          <em>{{ o.n }}</em>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
                <v-divider />
                <div v-if="vAccChart">
                  <div style="text-align: right;">
                    <span style="font-size:12px;cursor: pointer" @click="vAccChartDataView = !vAccChartDataView">{{
            vAccChartDataView ? '图表视图' : '数据视图' }}</span>
                  </div>
                  <keep-alive>
                    <v-data-table :headers="vAccTableHader" :items="vAccTableData" v-if="vAccChartDataView"
                      class="elevation-1" :rows-per-page-items="[50, 100, { text: '全部', value: -1 }]">
                      <template v-slot:items="props">
                        <td v-for="header in vAccTableHader" :key="header.text">{{ props.item[header.value] }}</td>
                      </template>
                    </v-data-table>
                    <v-chart v-else class="v-chart" autoresize :option="vAccChart" :style="{
            height: vAccChart.yAxis[0].data.length * 60 + 60 + 'px',
          }" @click="onBarClick" />
                  </keep-alive>
                </div>
              </v-tab-item>
            </v-tabs>
            <div v-if="orgCrud" class="org-list">
              <span class="alert-msg">
                <v-icon :size="16" color="orange">info</v-icon>可通过企业后面图标按钮做更多操作
              </span>
              <crud :cfg="orgCrud" />
            </div>
          </v-flex>
          <v-flex xs12 sm4 md3>
            <div class="grid-right">
              <v-chart class="v-chart-r" v-if="typeAccChart" :option="typeAccChart" autoresize />
              <v-chart class="v-chart-r" v-if="vTypeAccChart" :option="vTypeAccChart" autoresize />
              <v-chart class="v-chart-r" v-if="locAccChart" :option="locAccChart" autoresize />
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, PieChart } from "echarts/charts";

import {
  TitleComponent,
  TooltipComponent,
  ToolboxComponent,
  LegendComponent,
  GridComponent,
} from "echarts/components";

import { Crud } from "javaee-fre";
import VChart from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  ToolboxComponent,
  GridComponent,
]);

export default {
  name: "mo-stu-chart",
  components: {
    "v-chart": VChart,
    crud: Crud,
  },
  props: {
    loc: String,
  },
  data() {
    return {
      totalAcc: 0,
      typeAcc: [],
      accChart: null,
      typeAccChart: null,
      legendData: null,
      //-----新加一组：按照业务类型统计
      vTypeAcc: [],
      vAccChart: null,
      vTypeAccChart: null,
      vLegendData: null,
      //-----end:新加一组：按照业务类型统计
      locAccChart: null,
      locs: [],
      orgCrud: null,
      colors: this.$colors,
      vAccChartDataView: false,
      accChartDataView: false,
    };
  },
  computed: {
    accTableHader() {
      let series = this.accChart.series, headers = [{ text: '地区', value: 'region' }];
      for (let s of series) {
        headers.push({ text: s.name, value: s.name });
      }
      return headers;
    },
    accTableData() {
      let categories = this.accChart.yAxis[0].data, series = this.accChart.series, data = [], i = 0;
      for (let c of categories) {
        let row = { region: c };
        for (let s of series) {
          let d = s.data;
          row[s.name] = d[i];
        }
        data.push(row);
        i++;
      }
      return data;
    },
    vAccTableHader() {
      let series = this.vAccChart.series, headers = [{ text: '地区', value: 'region' }];
      for (let s of series) {
        headers.push({ text: s.name, value: s.name });
      }
      return headers;
    },
    vAccTableData() {
      let categories = this.vAccChart.yAxis[0].data, series = this.vAccChart.series, data = [], i = 0;
      for (let c of categories) {
        let row = { region: c };
        for (let s of series) {
          let d = s.data;
          row[s.name] = d[i];
        }
        data.push(row);
        i++;
      }
      return data;
    }
  },
  methods: {
    setLegendData(idx) {
      let legendData = this.legendData;
      if (legendData) {
        legendData[idx].show = !legendData[idx].show;
      }
    },
    setVLegendData(idx) {
      let legendData = this.vLegendData;
      if (legendData) {
        legendData[idx].show = !legendData[idx].show;
      }
    },
    onBarClick(b) {
      let self = this,
        rc = self.locs[b.dataIndex];
      self.$emit("bar_click", rc);
    },
    init() {
      let self = this,
        url = "/home/my/mo/summary/stu";
      if (self.loc) {
        url = url + "?_loc=" + self.loc;
      }
      self.$axios.get(url).then((r) => {
        if (r.data.status != "ok") {
          return;
        }
        let d = r.data.message,
          totalAcc = 0,
          typeAcc = [],
          typeHash = {},
          vTypeAcc = [],
          vTypeHash = {},
          regions = [];
        if (r.data.personTypes) {
          for (let t of r.data.personTypes) {
            typeHash[t.id] = t;
          }
        }

        if (r.data.vehicleTypes) {
          for (let t of r.data.vehicleTypes) {
            vTypeHash[t.id] = t;
          }
        }

        //进行数据的合并
        let keys = Object.keys(d);
        for (let k of keys) {
          let pt = d[k]['pt'], vt = d[k]['vt'], totalCount = d[k]['t'];
          totalAcc += totalCount;
          for (let tk in pt) {
            let
              o = pt[tk],
              ot = typeHash[tk];
            if (ot.c) {
              ot.c.c += o;
            } else {
              ot.c = { n: ot.name, c: o, k: tk };
              typeAcc.push(ot.c);
            }
          }
          for (let vk in vt) {
            let
              o = vt[vk],
              ot = vTypeHash[vk];
            if (ot.c) {
              ot.c.c += o;
            } else {
              ot.c = { n: ot.name, c: o, k: vk };
              vTypeAcc.push(ot.c);
            }
          }
        }

        let typeAccChart = {
          title: { subtext: "各人员类型占比" },
          tooltip: { show: true },
          series: [
            {
              type: "pie",
              label: { show: false },
              data: [],
            },
          ],
        },
          vTypeAccChart = {
            title: { subtext: "各业务类型占比" },
            tooltip: { show: true },
            series: [
              {
                type: "pie",
                label: { show: false },
                data: [],
              },
            ],
          },
          colorIdx = 0;
        for (let tac of typeAcc) {
          typeAccChart.series[0].data.push({
            value: tac.c,
            itemStyle: { color: self.colors[colorIdx++] },
            name: `${tac.n}(${((tac.c * 100) / totalAcc).toFixed(1)}%)`,
          });
        }
        colorIdx = 0;
        for (let tac of vTypeAcc) {
          vTypeAccChart.series[0].data.push({
            value: tac.c,
            itemStyle: { color: self.colors[colorIdx++] },
            name: `${tac.n}(${((tac.c * 100) / totalAcc).toFixed(1)}%)`,
          });
        }

        self.totalAcc = totalAcc;
        self.typeAcc = typeAcc;
        self.typeAccChart = typeAccChart;

        self.vTypeAcc = vTypeAcc;
        self.vTypeAccChart = vTypeAccChart;

        if (r.data.regions) {
          let locs = [];
          for (let rg of r.data.regions) {
            if (d[rg.id]) {
              regions.push(rg.name);
              locs.push({ id: rg.id, n: rg.name });
            }
          }
          self.locs = locs;

          //构建图表
          let series = [],
            vSeries = [],
            totalD = [],
            legendData = [],
            vLegendData = [],
            idx = 0,
            locAccChart = {
              title: {
                subtext: "各地区人员占比",
              },
              tooltip: { show: true },
              series: [
                {
                  type: "pie",
                  label: { show: false },
                  data: [],
                },
              ],
            };

          for (let s of typeAcc) {
            let color = self.colors[idx++];
            series.push({
              name: s.n,
              k: s.k,
              type: "bar",
              stack: "special",
              barWidth: 20,
              data: [],
              color: color
            });
            legendData.push({
              label: s.n,
              show: true,
            });
          }
          idx = 0;
          for (let s of vTypeAcc) {
            vSeries.push({
              name: s.n,
              k: s.k,
              type: "bar",
              stack: "special",
              barWidth: 20,
              data: [],
              color: self.colors[idx++],
            });
            vLegendData.push({
              label: s.n,
              show: true,
            });
          }

          for (let loc of r.data.regions) {
            let tmp = d[loc.id];
            if (!tmp) {
              continue;
            }
            let pt = tmp['pt'], vt = tmp['vt'], totalCount = tmp['t'];
            totalD.push(totalCount);
            for (let s of series) {
              let sc = pt[s.k] || 0;
              s.data.push(sc);
            }
            for (let s of vSeries) {
              let sc = vt[s.k] || 0;
              s.data.push(sc);
            }

            locAccChart.series[0].data.push({
              value: totalCount,
              name: `${loc.name}(${((totalCount * 100) / totalAcc).toFixed(1)}%)`,
            });
          }

          self.locAccChart = locAccChart;

          series.push({
            name: "总共",
            type: "bar",
            barWidth: 5,
            data: totalD,
            color: self.colors[idx],
            label: { show: true, position: "right" },
            itemStyle: { borderRadius: [0, 10, 10, 0] }
          });
          legendData.push({
            label: "总共",
            show: true,
          });
          self.legendData = legendData;

          vSeries.push({
            name: "总共",
            type: "bar",
            barWidth: 5,
            data: totalD,
            color: self.colors[idx],
            label: { show: true, position: "right" },
            itemStyle: { borderRadius: [0, 10, 10, 0] }
          });
          vLegendData.push({
            label: "总共",
            show: true,
          });
          self.vLegendData = vLegendData;

          let accChart = {
            title: {
              subtext:
                "没有显示的地区表示没有学员  | {tip|下面图表点击可以切换到具体的地区数据}",
              subtextStyle: {
                rich: {
                  tip: { color: "orange", fontSize: "10px" },
                },
              },
            },
            legend: {
              data: [],
              selected: {},
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            yAxis: [
              {
                type: "category",
                data: regions,
              },
            ],
            xAxis: [
              {
                type: "value",
              },
            ],
            series: series,
          }, vAccChart = {
            title: {
              subtext:
                "没有显示的地区表示没有学员  | {tip|下面图表点击可以切换到具体的地区数据}",
              subtextStyle: {
                rich: {
                  tip: { color: "orange", fontSize: "10px" },
                },
              },
            },
            legend: {
              data: [],
              selected: {},
            },
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            yAxis: [
              {
                type: "category",
                data: regions,
              },
            ],
            xAxis: [
              {
                type: "value",
              },
            ],
            series: vSeries,
          };
          self.accChart = accChart;
          self.vAccChart = vAccChart;
        } else if (keys.length == 1) {
          //列出下面的机构及统计信息
          self.orgCrud = {
            url: "/home/my/mo/org",
            params: { _loc: keys[0] },
            refreshable: false,
            countEndding: "家企业",
            listItemActions: [
              {
                label: "设为重点关注",
                confirm: "确认设为重点关注企业吗？",
                icon: "visibility",
                func(cfg) {
                  let crud = this;
                  crud.$axios
                    .get(`/home/my/mo/org/update/focus/${cfg.item.id}/true`)
                    .then(() => {
                      crud.refresh();
                    });
                },
              },
              {
                label: "取消重点关注",
                confirm: "确认重点关注企业中移除吗？",
                icon: "visibility_off",
                func(cfg) {
                  let crud = this;
                  crud.$axios
                    .get(`/home/my/mo/org/update/focus/${cfg.item.id}/false`)
                    .then(() => {
                      crud.refresh();
                    });
                },
              },
              {
                label: "学员",
                icon: "person",
                func(cfg) {
                  self.$emit("org_stu_click", cfg.item);
                },
              },
              {
                label: "培训计划",
                icon: "schedule",
                func(cfg) {
                  self.$emit("org_clazz_click", cfg.item);
                },
              },
            ],
            listItemFilter(i, acts) {
              if (i.focusOn) {
                this.delAction(acts, "icon", "visibility");
                i._rowClazz = "focus-on-row";
              } else {
                this.delAction(acts, "icon", "visibility_off");
              }
              return acts;
            },
          };
        }
      });
    },
  },
  created() {
    this.init();
  },
  watch: {
    legendData: {
      handler(val) {
        let obj = {};
        val.forEach((x) => {
          obj[x.label] = x.show;
        });
        this.accChart.legend.selected = obj;
      },
      deep: true,
    },
    vLegendData: {
      handler(val) {
        let obj = {};
        val.forEach((x) => {
          obj[x.label] = x.show;
        });
        this.vAccChart.legend.selected = obj;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.v-chart {
  width: 100%;
}

.v-chart-r {
  height: 250px;
}

.panel {
  margin: 8px;
}

.panel-1 {
  min-height: 70px;
}

.panel-1 .left-icon {
  float: left;
}

.panel-1 label {
  font-weight: bold;
  font-size: 16px;
  clear: left;
  font-size: 10px;
}

.panel-1 .label {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.org-list {
  margin-top: 16px;
}

.focus-on-row td {
  color: red !important;
}

.total-acc b {
  color: red;
  font-size: 18px;
  padding: 4px;
}

.alert-msg {
  color: orange;
  float: right;
  font-size: 10px;
}

.grid-right {
  background-color: #f8f8f8;
  border-radius: 8px;
  padding: 8px;
  margin: 8px;
}

.v-tabs__container {
  height: 32px !important;
}

.v-tabs__container .v-tabs__div {
  font-size: 12px !important;
  font-weight: normal !important;
}

.v-tabs__container .v-tabs__slider {
  height: 1px !important;
}
</style>